import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "analysis-history-item" }
const _hoisted_2 = {
  key: 1,
  class: "analysis-history-item__unknown"
}

import { PropType, toRefs } from 'vue';
import { useI18n } from 'vue-i18n';

import { SyntheticAnalysisStatus, TimelineStatus } from '@/Analysis/analysis.entity';
import AnalysisStatusBadge from '@/components/AnalysisStatusBadge.vue';
import MemberAvatar from '@/components/MemberAvatar.vue';
import { Member } from '@/Member/member.entity';


export default /*#__PURE__*/_defineComponent({
  __name: 'AnalysisHistory',
  props: {
    statuses: {
        type: Array as PropType<{ status: TimelineStatus; createdAt: Date; member?: Member }[]>,
        required: true,
    },
},
  setup(__props) {

const props = __props;

const { t } = useI18n();



const { statuses } = toRefs(props);

const connectorFor = (status: TimelineStatus): string =>
    status === SyntheticAnalysisStatus.ASSIGNED_TO ? 'common.to' : 'common.by';

return (_ctx: any,_cache: any) => {
  const _component_el_timeline_item = _resolveComponent("el-timeline-item")!
  const _component_el_timeline = _resolveComponent("el-timeline")!

  return (_openBlock(), _createBlock(_component_el_timeline, null, {
    default: _withCtx(() => [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(statuses), ({ status, createdAt, member }, index) => {
        return (_openBlock(), _createBlock(_component_el_timeline_item, {
          key: `${status}-${createdAt}-${index}`,
          timestamp: 
                new Date(createdAt).toLocaleDateString(undefined, {
                    year: 'numeric',
                    month: 'numeric',
                    day: 'numeric',
                    hour: '2-digit',
                    minute: '2-digit',
                })
            ,
          size: "large"
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_1, [
              _createVNode(AnalysisStatusBadge, { status: status }, null, 8, ["status"]),
              _createElementVNode("span", null, _toDisplayString(_unref(t)(connectorFor(status))), 1),
              member
                ? (_openBlock(), _createBlock(MemberAvatar, {
                    key: 0,
                    member: member
                  }, null, 8, ["member"]))
                : (_openBlock(), _createElementBlock("span", _hoisted_2, _toDisplayString(_unref(t)('common.unknownUser')), 1))
            ])
          ]),
          _: 2
        }, 1032, ["timestamp"]))
      }), 128))
    ]),
    _: 1
  }))
}
}

})